import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'lightStackFilter' })

export class LightStackFilter implements PipeTransform {

  transform(items: any[]): any[] {
    const filteredItems = items.filter(function(val){
     if(val && val.obj && val.obj.min && val.obj.max && val.obj.min != 0 && val.max != 0){
        return val;
      }
    });
    filteredItems.sort((a, b) => b.obj.min - a.obj.min);
    
    return filteredItems;
  }
}
